/* 🤖 this file was generated by svg-to-ts */
export const matIconStar: {
  name: 'star';
  data: string;
} = {
  name: 'star',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"/></svg>`
};
